export function formatPhone(value) {
  if (!value) return "";

  const digits = value.toString().replace(/\D/g, "");

  if (digits.length === 13) {
    const ddi = digits.slice(0, 2);
    const ddd = digits.slice(2, 4);
    const number = digits.slice(4);

    if (number.length === 9) {
      return `+${ddi} (${ddd}) ${number.slice(0, 5)}-${number.slice(5)}`;
    }

    if (number.length === 8) {
      return `+${ddi} (${ddd}) ${number.slice(0, 4)}-${number.slice(4)}`;
    }
  }

  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }

  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }

  return value;
}
